module.exports = __webpack_public_path__ + "img/asass_logo.f36b9bf6.jpg";